import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-white" data-id="element-352">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-353">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg md:prose-xl text-stone-600 mx-auto" data-id="element-354">
          <p className="lead text-2xl md:text-3xl font-medium text-stone-800 text-center mb-12 leading-relaxed" data-id="element-355">
            Te despiertas sintiéndote bien, pero a las 4 de la tarde tu abdomen
            parece tener vida propia. La ropa te aprieta, te sientes pesada y
            esa inflamación mental no te deja enfocarte.
          </p>

          <div className="bg-stone-50 rounded-2xl p-8 md:p-10 mb-16 border border-stone-100 shadow-sm" data-id="element-356">
            <div className="flex items-start mb-4" data-id="element-357">
              <AlertCircle className="w-8 h-8 text-amber-500 mr-4 flex-shrink-0 mt-1" data-id="element-358" />
              <p className="text-xl font-medium text-stone-800 m-0" data-id="element-359">
                No es falta de voluntad y no es solo "grasa". Es tu cuerpo
                atrapado en un ciclo de cortisol y mala digestión que ninguna
                dieta de hambre puede solucionar.
              </p>
            </div>
          </div>

          <h2 className="text-3xl font-bold text-stone-900 mb-6 text-center" data-id="element-360">
            El Problema con las "Dietas" Tradicionales
          </h2>

          <p className="mb-8 text-center" data-id="element-361">
            La mayoría de los planes de "descenso de peso" en Argentina cometen
            el mismo error: te piden que comas menos y corras más.
          </p>

          <p className="mb-12 text-center font-medium text-stone-800" data-id="element-362">
            Para un cuerpo inflamado, eso es combustible para el fuego. El
            exceso de ejercicio y la restricción calórica extrema elevan el
            cortisol, lo que le ordena a tu cuerpo retener cada gramo de agua y
            gas como mecanismo de defensa. Por eso, aunque "te cuides", tu
            abdomen sigue ahí, duro e inflamado.
          </p>

          <div className="space-y-6" data-id="element-363">
            <h3 className="text-2xl font-bold text-stone-900 mb-6" data-id="element-364">
              Por qué lo que intentaste no funcionó:
            </h3>

            {['Las dietas hipocalóricas aumentan el estrés hormonal y bloquean la quema de grasa abdominal.', 'Los productos "Light" están llenos de edulcorantes que destruyen tu microbiota y generan más gas.', 'El cardio excesivo sin descanso inflama tus células y agota tus glándulas suprarrenales.', 'El trigo moderno y los aceites de semillas industriales mantienen tu intestino en alerta roja constante.'].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start bg-red-50/50 p-4 rounded-xl" data-id="element-365">
                <XCircle className="w-6 h-6 text-red-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-366" />
                <p className="m-0 text-stone-700" data-id="element-367">{item}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}